<template>
    <div
        class="order-address-form__form-group form-group"
        :class="{ 'has-error': $parent.$v.form.attention_by.$error }"
    >
        <div class="order-address-form__form-group-item order-address-form__form-group-item--single">
            <label class="order-address-form__select-label" for="attention_by">
                <span class="label-text">
                    Wie hast du uns gefunden?
                </span>
                <span class="required-symbol"><span class="sr-only" lang="en">(Pflichtfeld)</span></span>
            </label>
            <select
                v-model="$parent.form.attention_by"
                class="selectpicker"
                name="attention_by"
                title="Bitte wählen"
                data-container="body"
            >
                <option value="Velokurier gesehen" selected="selected">Velokurier gesehen</option>
                <option value="Flyer">Flyer</option>
                <option value="Internet">Internet</option>
                <option value="Presse">Presse</option>
                <option value="Freunde">Freunde</option>
                <option value="Geschenk">Geschenk</option>
                <option value="War schon mal Kunde">War schon mal Kunde</option>
                <option value="Sonstiges">Sonstiges</option>
            </select>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'; // eslint-disable-line

export default {
    mounted() {
        $(window).trigger('initBootstrapSelect');
        $('select').selectpicker();
    },
};
</script>



// WEBPACK FOOTER //
// AttentionBy.vue?be70a25e